TeamEditionController.$inject = ['$scope', '$mdDialog', '$state', '$stateParams', '$translate', 'loggedUser',
  'UsersRolesFactory', 'TopToolbarFactory', 'AlertingFactory', 'ConfirmationFactory', 'company'];
export function TeamEditionController($scope, $mdDialog, $state, $stateParams, $translate, loggedUser,
  UsersRolesFactory, TopToolbarFactory, AlertingFactory, ConfirmationFactory, company) {

  $scope.updateSaveBtn = updateSaveBtn;
  $scope.addUsers = addUsers;
  $scope.removeUser = removeUser;
  $scope.updateRoutableTeams = updateRoutableTeams;
  $scope.onUserClick = onUserClick;
  $scope.goBack = goBack;

  function save() {
    UsersRolesFactory.updateTeam(company.id, $scope.team)
      .then(() => {
        AlertingFactory.success('users_roles/update_team_success');
        disableSave();
      }, AlertingFactory.httpErrorHandler());
  }

  function enableSave() {
    TopToolbarFactory.updateButtonDisable(false, $scope);
    $scope.saveBtnState = 1;
  }

  function disableSave() {
    TopToolbarFactory.updateButtonDisable(true, $scope);
    $scope.saveBtnState = 0;
  }

  function updateSaveBtn() {
    // Team name mandatory - disable save btn if not filled 
    $scope.team.label && $scope.team.label != '' ? enableSave() : disableSave();
  }

  // Add a user to this team
  function addUsers() {
    UsersRolesFactory.sortUsersSitesRoles($scope.usersNotInTeam, 'name');

    $mdDialog.show({
      'controller': 'AssignUserController',
      'template': require('./assign-user.dialog.html'),
      'targetEvent': event,
      'clickOutsideToClose': false,
      'locals': {
        assignableUsers: $scope.usersNotInTeam
      }
    })
      .then(async function (addedUsers) {
        for (let index = 0; index < addedUsers.length; index++) {
          const id = addedUsers[index];
          await UsersRolesFactory.addUserInTeam(company.id, $scope.team.id, id)
            .then(() => {
              const userObj = $scope.allUsers.find(user => user.id === id);
              $scope.usersInTeam.push(userObj);
              $scope.usersNotInTeam = $scope.usersNotInTeam.filter(user => !addedUsers.includes(user.id));
              $scope.team.nusers = $scope.usersInTeam.length;
            })
            .catch(AlertingFactory.httpErrorHandler());
        }
      });
  }

  // Remove a user from this team
  function removeUser(user) {
    ConfirmationFactory.materialConfirmDialog('users_roles/confirm_user_deletion_from_team')
      .then(function () {
        UsersRolesFactory.deleteUserFromTeam(company.id, $scope.team.id, user.id)
          .then(() => {
            $scope.usersNotInTeam.push(user);
            $scope.usersInTeam = $scope.usersInTeam.filter(u => u.id !== user.id);
            $scope.team.nusers = $scope.usersInTeam.length;
          })
          .catch(AlertingFactory.httpErrorHandler());

      });
  }

  // Remove team if it's already included, add it otherwise
  function updateRoutableTeams(team) {
    $scope.team.routable_teams.includes(team.id)
      ? $scope.team.routable_teams = $scope.team.routable_teams.filter(id => id != team.id)
      : $scope.team.routable_teams.push(team.id);
  }

  // Open the user edition page in a new tab on user email click
  function onUserClick($event, user) {
    UsersRolesFactory.redirectToUserEdit($event, user, true);
  }

  // Go back to users or teams table depending on where we got here from
  function goBack() {
    UsersRolesFactory.redirectToUsersTeamsRoles($state, $stateParams.trackTable === 'users' ? 0 : 1)
  }

  init();

  function init() {
    $scope.sortColumn = 'label';
    // If there is no team passed to team edition redirect back to main page
    if (!$stateParams.team.name) {
      UsersRolesFactory.redirectToUsersTeamsRoles($state, 0);
    }

    $scope.team = $stateParams.team;
    // When we create a team and uncheck all other routable teams, we still want to have the team in question in the routable_teams list
    // So it doesn't appear in the routing options from other teams. Problem seen in SF case 1895.
    if ($scope.team.routable_teams && !$scope.team.routable_teams.includes($scope.team.id)) {
      $scope.team.routable_teams.push($scope.team.id)
    }

    $scope.routableTeamsLabel = $translate.instant('users_roles/routable_teams');
    $scope.selectedUser = $stateParams.user;

    $scope.backToLabel = $stateParams.trackTable === 'users' ? $translate.instant('users_roles/back_to_users_table') : $translate.instant('users_roles/back_to_teams_table');

    TopToolbarFactory.setFirstLevelNavTranslation('users_roles/teams', $scope, () => UsersRolesFactory.redirectToUsersTeamsRoles($state, 1));
    TopToolbarFactory.setTitle($scope.team.label, $scope);
    TopToolbarFactory.setButton('save', save, $scope);
    disableSave();

    UsersRolesFactory.getTeams(company.id, true)
      .then(res => {
        $scope.allRoutableTeams = res.data.filter(team => team.tag_id !== $scope.team.id);
        $scope.allRoutableTeams.forEach(team => {
          team.id = team.tag_id;
          team.label = team.name;
        });
      }, AlertingFactory.httpErrorHandler());

    UsersRolesFactory.getUsersV2(company.id)
      .then(res => {
        $scope.allUsers = res.data;
        $scope.usersInTeam = $scope.allUsers.filter(user => user.teams.map(({ id }) => id).includes($scope.team.id));
        $scope.usersNotInTeam = $scope.allUsers.filter(user => !user.teams.map(({ id }) => id).includes($scope.team.id));
      }, AlertingFactory.httpErrorHandler());
  }

  $scope.$watch('team.label', () => {
    TopToolbarFactory.setTitle($scope.team.label, $scope);
    $scope.usersCardTitle = loggedUser.lang === 'fr'
      ? $translate.instant('users_roles/users_card_title_team') + ' "' + $scope.team.label + '"'
      : $translate.instant('users_roles/users_card_title_team') + ' "' + $scope.team.label + '" ' + $translate.instant('users_roles/team').toLowerCase();
  });
  $scope.$watch('selectedIndex', () => {
    if ($scope.selectedIndex == 0) {
      TopToolbarFactory.setButton('save', save, $scope);
      $scope.saveBtnState == 1 ? enableSave() : disableSave();
    } else {
      TopToolbarFactory.setButton('users_roles/add_users', addUsers, $scope);
    }
  });
}
